// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.vue-app-wrapper .card.app-card {\n        border: 1px solid #e9ecef !important;\n}\n.vue-app-wrapper .card.app-card:hover {\n        border-color: #dee2e6 !important;\n}\n", ""]);
// Exports
module.exports = exports;
